module.exports = __webpack_public_path__ + "img/c3.6df84ab5.svg";